import { UnreadDot } from '@lib/components'
import { CommentLight } from '@octopus-do/octopus-storybook/icons'
import { selectHasUnread } from '@store/reducers/commentReads'
import type React from 'react'
import { useSelector } from 'react-redux'

import css from './styles.module.css'

interface Props {
  className?: string
}

// The comment tool's icon with the one mark on the board: something unread
// in a pin, a block or a page, the panel says where. Shaped as an icon
// component so the action bar's button takes it like any other icon.
export const CommentsToolbarIcon: React.FC<Props> = ({ className = '' }) => {
  const unread = useSelector(selectHasUnread)

  return (
    <span className={css.container}>
      <CommentLight className={className} />
      {unread && <UnreadDot className={css.unread} />}
    </span>
  )
}
